import { useEffect } from "react";
import { tWithKeyAttr as t } from "../i18nHelper";


// Updates the height of a <textarea> when the value changes.
const useAutosizeTextArea = (
  textAreaRef: HTMLTextAreaElement | null,
  value: string
) => {
  useEffect(() => {
    if (textAreaRef) {
      // We need to reset the height momentarily to get the correct scrollHeight for the textarea
      textAreaRef.style.height = "0px";
      const scrollHeight = textAreaRef.scrollHeight;

      textAreaRef.style.height = scrollHeight + "px";
      textAreaRef.style.maxHeight = "unset";
    }
  }, [textAreaRef, value]);
};

export default useAutosizeTextArea;
